<template>
  <div>
    <carousel :perPage="1" :paginationEnabled="false">
      <slide>
        <div class="padding">
          <span class ="arch">
            <p>More and more another city becomes clear to me, each page I read leads to another recollection, and blank pages seem to fill every time I put it to one side. </p>
            <p>There is a street here in this city that reminds me . . . that looks so like the Ribbonway that it is like being there. That halfway place, which connects zone to zone and is constantly full of noise, that place is here too. When I walk the street that ascends from the harbour, reaching upward into the sky, pushing the clouds away, I feel the songs I half recall lift through me. </p>
            <p>I think I met someone there. Once, I spilled fruit and food and met someone. A market, or a circle of stalls. </p>
            <p>The site has presence here, and there. </p>
            <p>I don't know who I met though. I remember a necklace, and dark hair. Nothing more. </p>
            <p>I walk up the hill, toward the horizon, and I try to make my footsteps beat time, sound a rhythm that will bring those moments back. </p>
            <p> &nbsp;</p>
            <p> &nbsp;</p>
          </span>
        </div>
      </slide>
    </carousel>
  </div>
</template>

<script>
export default {

  name: '1',

  data () {
    return {
      title: 'A Reflection'
    }
  }
}
</script>

<style lang="css" scoped>
</style>
